
































































































































import Vue from 'vue'
import _ from 'lodash'
import { GET_CURRENT_USER_ID, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { DxColumn, DxDataGrid, DxScrolling, DxSelection } from 'devextreme-vue/data-grid'
import {
  FETCH_ADDRESS_FELD_LIST,
  FETCH_ADDRESS_GROUP,
  FETCH_LAND_LIST,
  FETCH_SEARCH_ADDRESS_LIST
} from '@/store/action-types'
import { Land } from '@/model/addresses/Land'
import AddressWindow from '@/components/master-data/address/AddressWindow.vue'
import { AddressGroup } from '@/model/addresses/AddressGroup'
import {
  AdressZusatzfelderType,
  AdressZusatzfelderTypesResponse,
  ProjectAddressSearchResponse
} from '@/types/service-response'
import { SearchAddress } from '@/model/addresses/SearchAddress'
import { AdressZusatzfelderSearchItem, ProjectAddressSearchRequestPayload } from '@/types/payload'
import { AddressCountry } from '@/model/addresses/AddressCountry'

interface ComponentData {
  tableHeight: string,
  loading: boolean
  showDialog: boolean
  addressIdList: number[]

  landList: Land[]
  addressGroupList: AddressGroup[]

  sortierung: string
  name: string
  vorname: string
  ort: string
  plz: string
  strasse: string
  region: string
  land: AddressCountry | undefined
  adressgruppe: number | undefined
  telefonprivate: string
  telefongeschaftlich: string
  mailprivat: string
  mailgeschaftlich: string
  maxRecords: number

  addressList: SearchAddress[]
  isDetailButtonDisabled: boolean
  addressStatus: string
  feldList: AdressZusatzfelderType[]
  operatorList: any[]
  boolOperatorNextList: any[]
  additionalFilterList: any[]
}

export default Vue.extend({
  name: 'AddressSearchPage',

  components: {
    AddressWindow,
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxSelection
  },

  props: {
    addressGroupId: Number
  },

  data (): ComponentData {
    return {
      tableHeight: '',
      loading: false,
      showDialog: false,
      addressIdList: [],

      landList: [],
      addressGroupList: [],

      sortierung: '',
      name: '',
      vorname: '',
      ort: '',
      plz: '',
      strasse: '',
      region: '',
      land: undefined,
      adressgruppe: undefined,
      telefonprivate: '',
      telefongeschaftlich: '',
      mailprivat: '',
      mailgeschaftlich: '',
      maxRecords: 500,

      addressList: [],
      isDetailButtonDisabled: true,
      addressStatus: '1',
      feldList: [],
      operatorList: [
        {id: 1, name: '='},
        {id: 2, name: 'Like'},
        {id: 3, name: 'grosser'},
        {id: 4, name: 'grosser gleich'},
        {id: 5, name: 'kleiner'},
        {id: 6, name: 'kleiner gleich'},
        {id: 7, name: 'nicht gleich'},
        {id: 8, name: 'nicht wie'}
      ],
      boolOperatorNextList: [
        {id: 0, name: ''},
        {id: 1, name: 'UND'},
        {id: 2, name: 'ODER'}
      ],
      additionalFilterList: [
        {id: 1, feld: null, operator: null, inhalt: '', boolOperatorNext: null}
      ]
    }
  },

  watch: {
    $route (newVal: any): void {
      if(newVal.query.create) {
        this.addressIdList = [0]
        this.showDialog = true
      }
    },

    addressGroupId (newVal: number): void {
      if(newVal) {
        this.adressgruppe = newVal
      }
    }
  },

  computed: {
    currentUserId (): number {
      return this.$store.getters[GET_CURRENT_USER_ID]
    },

    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },
  },

  methods: {
    onChangeFeld (index: number, item: any): void {
      if(item === 0) {
        this.additionalFilterList[index].feld = null
        this.additionalFilterList[index].operator = null
        this.additionalFilterList[index].inhalt = ''
        this.additionalFilterList[index].boolOperatorNext = 0
        this.additionalFilterList.splice(index + 1, this.additionalFilterList.length)
      }
    },

    onChangeAdditional (index: number, item: any): void {
      if(item === 0) {
        if(this.additionalFilterList && this.additionalFilterList[index + 1]) {
          this.additionalFilterList.splice(index + 1, 1)
        }
      } else {
        if(this.additionalFilterList && !this.additionalFilterList[index + 1]) {
          const highId = _.maxBy(this.additionalFilterList, 'id')
          this.additionalFilterList.push({id: highId.id + 1, feld: null, operator: null, inhalt: '', boolOperatorNext: 0})
        }
      }
    },

    startCreate (): void {
      this.addressIdList = [0]
    },

    addressCreated (id: number): void {
      this.addressIdList = [id]
    },

    addressEdited (): void {
      this.searchAddress()
    },

    addressDeleted (id: number) : void {
      this.addressIdList.splice(this.addressIdList.indexOf(id), 1)
      if(this.addressIdList.length === 0) {
        this.showDialog = false
        this.searchAddress()
      } else {
        this.searchAddress()
      }
    },

    onCloseDialog (): void {
      this.showDialog = false
      this.addressIdList = []
      let data: any = this.getRouteData()
      if(data.showDialog !== undefined) {
        delete data.showDialog
      }
      if(data.addressTab != undefined) {
        delete data.addressTab
      }
      if(data.addressIdIndex !== undefined) {
        delete data.addressIdIndex
      }
      if(data.addressTab2 !== undefined) {
        delete data.addressTab2
      }
      this.$router.push({name: 'AddressSearch', query: { data: JSON.stringify(data) }})
      /*if(this.addressGroupId) {
        this.$router.push({ path: `/address/${this.addressGroupId}`})
      } else {
        this.$router.push({ path: '/address'})
      }*/
    },

    onSearchButtonClick (): void {
      this.addressList = []

      let data: any = this.getRouteData()

      data.sortierung = this.sortierung
      data.name = this.name
      data.vorname = this.vorname
      data.ort = this.ort
      data.plz = this.plz
      data.strasse = this.strasse
      data.region = this.region
      data.land = this.land
      data.adressgruppe = this.adressgruppe
      data.telefonprivate = this.telefonprivate
      data.telefongeschaftlich = this.telefongeschaftlich
      data.mailprivat = this.mailprivat
      data.mailgeschaftlich = this.mailgeschaftlich
      data.addressStatus = this.addressStatus
      data.adressZusatzfelderSearchItems = this.additionalFilterList

      this.$router.push({name: 'AddressSearch', query: { data: JSON.stringify(data) }})

      this.searchAddress()
    },

    onSelectionChanged (data: any) {
      this.isDetailButtonDisabled = data.selectedRowKeys.length <= 0

      let ruteData: any = this.getRouteData()
      ruteData.selectedRowKeys = data.selectedRowKeys
      this.$router.push({name: 'AddressSearch', query: { data: JSON.stringify(ruteData) }})
    },

    rowDblClick(event: any): void {
      this.addressIdList.push(event.data.id)
      this.showDialog = true

      let ruteData: any = this.getRouteData()
      ruteData.selectedRowKeys = [event.data.id]
      ruteData.showDialog = this.showDialog
      this.$router.push({name: 'AddressSearch', query: { data: JSON.stringify(ruteData) }})
    },

    onDetailClick (): void {
      //@ts-ignore
      const selectedAddressIdList: number[] = this.$refs.dataGrid.instance.getSelectedRowKeys()

      if(selectedAddressIdList.length > 0) {
        this.addressIdList = selectedAddressIdList
        this.showDialog = true

        let ruteData: any = this.getRouteData()
        ruteData.showDialog = this.showDialog
        this.$router.push({name: 'AddressSearch', query: { data: JSON.stringify(ruteData) }})
      }
    },

    onResize (): void {
      if(this.$refs.filter && this.$vuetify.breakpoint.mdAndUp) {
        const vh = window.innerHeight
        if(vh > 500) {
          const height = (this.$refs.filter as HTMLElement).clientHeight
          this.tableHeight = `height: calc(${vh}px - 105px - ${height}px)`
        } else {
          this.tableHeight = '300px'
        }
      } else {
        this.tableHeight = '300px'
      }
    },

    async searchAddress (): Promise<void> {
      let additionalFilterSearchList: AdressZusatzfelderSearchItem[] = []
      this.additionalFilterList.forEach((item: any) => {
        if(item.feld && item.operator && item.inhalt) {
          additionalFilterSearchList.push({
            Feldtyp: item.feld,
            Operator: item.operator,
            BoolOperatorNext: item.boolOperatorNext,
            Inhalt: item.inhalt
          })
        }
      })
      const payload: ProjectAddressSearchRequestPayload = {
        Sortierung: this.sortierung,
        Adressgruppe: this.adressgruppe ? this.adressgruppe.toString() : '',
        Name: this.name,
        Region: this.region,
        Vorname: this.vorname,
        Land: this.land ? this.land.name : '',
        Ort: this.ort,
        Telefonprivate: this.telefonprivate,
        Telefongeschaftlich: this.telefongeschaftlich,
        AdressZusatzfelderSearchItems: additionalFilterSearchList,
        PLZ: this.plz,
        Mailprivat: this.mailprivat,
        Strasse: this.strasse,
        Mailgeschaftlich: this.mailgeschaftlich,
        Sprache: this.selectedLanguageId,
        Mitarbeiter: this.currentUserId,
        MaxRecords: this.maxRecords,
        Aktiv: this.addressStatus === '1',
        Passiv: this.addressStatus === '2',
        Alle: this.addressStatus === '0',
      }

      try {
        this.loading = true
        const response: ProjectAddressSearchResponse = await this.$store.dispatch(FETCH_SEARCH_ADDRESS_LIST, payload)
        if(!response.IsError) {
          this.addressList = SearchAddress.createFromResponse(response.Results)

          let data: any = this.getRouteData()
          if(this.$route.path === '/address' && data.selectedRowKeys) {
            let selectedRowKeyList: number[] = []
            this.addressList.forEach((item: SearchAddress) => {
              if(data.selectedRowKeys.includes(item.id)) {
                selectedRowKeyList.push(item.id)
              }
            })

            setTimeout(() => {
              //@ts-ignore
              this.$refs.dataGrid.instance.selectRows(selectedRowKeyList)
              this.showDialog = data.showDialog !== undefined && selectedRowKeyList.length > 0 ? data.showDialog : false
            }, 100)
          }
        }
        this.loading = false
      } catch {
        this.loading = false
      }
    },

    async fetchFeldList (): Promise<void> {
      try {
        const response: AdressZusatzfelderTypesResponse = await this.$store.dispatch(FETCH_ADDRESS_FELD_LIST)
        if(!response.IsError) {
          this.feldList = response.Data
          this.feldList.unshift({
            ID: 0,
            Bezeichnung: ''
          })
        }
      } catch {
      }
    },

    getRouteData (): Object {
      let data: any = undefined
      try {
        //@ts-ignore
        data = this.$route && this.$route.query && this.$route.query.data ? JSON.parse(this.$route.query.data) : {}
      } catch (e) {
        data = {}
      }

      return data
    },

    setDataFromRoute () {
      let data: any = this.getRouteData()

      if(this.$route.path === '/address') {
        this.sortierung = data && data.sortierung ? data.sortierung : ''
        this.name = data && data.name ? data.name : ''
        this.vorname = data && data.vorname ? data.vorname : ''
        this.ort = data && data.ort ? data.ort : ''
        this.plz = data && data.plz ? data.plz : ''
        this.strasse = data && data.strasse ? data.strasse : ''
        this.region = data && data.region ? data.region : ''
        this.land = data && data.land ? data.land : undefined
        this.adressgruppe = data && data.adressgruppe ? data.adressgruppe : undefined
        this.telefonprivate = data && data.telefonprivate ? data.telefonprivate : ''
        this.telefongeschaftlich = data && data.telefongeschaftlich ? data.telefongeschaftlich : ''
        this.mailprivat = data && data.mailprivat ? data.mailprivat : ''
        this.mailgeschaftlich = data && data.mailgeschaftlich ? data.mailgeschaftlich : ''
        this.addressStatus = data && data.addressStatus ? data.addressStatus : '1'
        this.additionalFilterList = data && data.adressZusatzfelderSearchItems ? data.adressZusatzfelderSearchItems : [{id: 1, feld: null, operator: null, inhalt: '', boolOperatorNext: null}]

        this.addressIdList = data.selectedRowKeys ? data.selectedRowKeys : []

        if(!_.isEmpty(data)) {
          this.searchAddress()
        }
      }
    }
  },

  async mounted (): Promise<void> {
    this.setDataFromRoute()
    if(this.$route.query.create) {
      this.addressIdList = [0]
      this.showDialog = true
    }

    if(this.addressGroupId) {
      this.adressgruppe = this.addressGroupId
    }

    this.landList = await this.$store.dispatch(FETCH_LAND_LIST)
    this.addressGroupList = await this.$store.dispatch(FETCH_ADDRESS_GROUP)
    this.fetchFeldList()
  }
})
